import { Injectable } from "@angular/core";
import { VariantEvaluationFrontendParameter } from "../models/VariantEvaluationFrontendParameter.model";
import { BaseEvaluationService } from "./BaseEvaluationService";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class VariantEvaluationService extends BaseEvaluationService<VariantEvaluationFrontendParameter> {
    public entity: BehaviorSubject<any> = new BehaviorSubject(null);
    constructor() {
        super();
    }

    public initializeEvaluationFrontendParameter() {
        super.initializeEvaluationFrontendParameter(new VariantEvaluationFrontendParameter());
    }
}
